// this is the error type of conversion goals
import { StringsMapping } from './strings';

export const ErrorType = {
  NoRecentConversion: 'NoRecentConversion',
  RecordingConversions: 'RecordingConversions',
  TagInactive: 'TagInactive',
  Unverified: 'Unverified',
  UnavailableTag: 'InactiveDueToTagUnavailable',
};

export const Errors = {
  [ErrorType.NoRecentConversion]: {
    ClassName: 'no-recent-conversion',
    Title: StringsMapping.NoRecentConversion,
    Message: StringsMapping.StatusMessage_NoRecentConversion,
    Status: StringsMapping.Status_RecentConversions,
  },
  // No revenue attribute
  [ErrorType.RecordingConversions]: {
    ClassName: 'no-revenue-attribute',
    Title: StringsMapping.RecordingConversions,
    Message: StringsMapping.StatusMessage_RecordingConversions,
    Status: StringsMapping.Status_RecordingConversions,
  },
  [ErrorType.TagInactive]: {
    ClassName: 'tag-inactive',
    Title: StringsMapping.InactiveTag,
    Message: StringsMapping.StatusMessage_TagInactive,
    Status: StringsMapping.Status_Inactive,
  },
  [ErrorType.Unverified]: {
    ClassName: 'unverified-tags',
    Title: StringsMapping.UnverifiedTag,
    Message: StringsMapping.StatusMessage_Unverified,
    Status: StringsMapping.Status_Unverified,
  },
  [ErrorType.UnavailableTag]: {
    ClassName: 'unavailable-tags',
    Title: StringsMapping.UnavailableTag,
    Message: StringsMapping.StatusMessage_InactiveDueToTagUnavailable,
    Status: StringsMapping.Status_Unavailable,
  },
};
